// extracted by mini-css-extract-plugin
module.exports = {"additionalDishList":"_3q51mHY4vytlTU7foO3Si5","externalId":"_3gZAl-nCjCgvUF_A4-2_bo"};